<template>
  <div
    id="w-node-28fcb8ef5e13-5ade2a58"
    :class="cssClass"
    :style="[thisSelected ? { 'box-shadow': '1px 1px 0 7px #ee645a' } : '']"
  >
    <a href="#" @click="selectAddon">
      <h4 class="add-onn">
        {{ addon.display_name }}
      </h4>
      <p class="text-white add-onn">
        {{ addon.description }}
      </p>
      <div class="add-onn-dark">
        <h4 class="price-add-ons" v-if="suppress_monthly_payment_option">
          $
          <span class="big-text"
            >{{ addon.annual_base_price | toMonetary }} </span
          >/ Year
        </h4>
        <h4 class="price-add-ons" v-else>
          $
          <span class="big-text">{{ addon.base_price | toMonetary }} </span>/
          Month
        </h4>
        <a href="#" class="button ghost add-onn-button w-button">Select</a>
      </div>
    </a>
  </div>
</template>

<script>
import Util from "../../helpers/Util";
export default {
  name: "SignupAddonComponent",
  filters: {
    toMonetary: function (value) {
      return Util.ConvertRealToMonetaryZero(value);
    },
    toRewards: function (plan) {
      return (plan.rewards * (12 / plan.frequency)).toFixed(0);
    },
  },
  props: {
    addon: {
      type: Object,
      default: null,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
    cssClass: {
      type: String,
      default: "feature left add-ons mint-addon",
    },
  },
  data() {
    return {
      suppress_monthly_payment_option: false,
    };
  },
  created() {
    this.suppress_monthly_payment_option =
      this.company.company.suppress_monthly_payment_option;
  },
  computed: {
    thisSelected() {
      if (this.addon.selected) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    selectAddon() {
      this.addon.selected = !this.addon.selected;
    },
  },
};
</script>


<style lang="scss">
.text-white.add-onn {
  height: 200px;
}
</style>
